import { defined } from "@formant/core/common/defined";
import { IUser } from "@formant/core/model/IUser";
import { Uuid } from "@formant/core/model/Uuid";

import { userStore } from "../stores";

export function formatUserDisplayName(user: IUser): string {
    return user.firstName?.trim() || defined(user.email);
}

export function formatUserIdDisplayName(
    userId: Uuid,
): string | undefined | false {
    const user = userStore.get(userId);
    return user && formatUserDisplayName(user);
}
